/**
 * ObjectMediaURLSupplement React component
 * 
 * @author    Jens Gruschel
 * @copyright © 2018 contexagon GmbH
 */


// React
import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

// Material-UI
import {withStyles} from "@material-ui/core";

// application components
import FileUploadPanel from "../base/FileUploadPanel";
import MediaPanel from "../base/MediaPanel";

// application functionality
import {openMediaOverlayForUrl} from "../../operations/view";
import {uploadMediaFile} from "../../operations/media";
import {getMediaType} from "../../utils";


/**
 * ObjectMediaURLSupplement allows uploading and showing media files
 *
 * @author Jens Gruschel
 */
export class ObjectMediaURLSupplement extends React.Component {

    state = {
        uploading: false
    }

    onDrop = (acceptedFiles, rejectedFiles) => {
        if (!this.props.readOnly && acceptedFiles.length > 0) {
            const file = acceptedFiles[0];
            this.setState({uploading: true});
            this.props.uploadMediaFile(
                file,
                this.props.objectId,
                this.props.fieldDef.id,
                (errorMessage, url, mediaInfo) => this.onFinish());
        }
    }

    onFinish() {
        this.setState({uploading: false});
    }

    render() {

        const url = this.props.value;

        if (!this.props.fieldDef.withUpload) {
            return null;
        }
        else if (url) {

            let onClick = undefined;
            switch(getMediaType(url)) {

                case "video":
                case "image":
                    onClick = () => this.props.openMediaOverlayForUrl(url);
                    break;

                default:
                    onClick = undefined;
                    break;
            }

            return <div style={{cursor: "pointer"}} onClick={onClick}>
                <MediaPanel url={url} showControls={true} playOnClick={false} otherFilesAsDownload={true} />
            </div>;
        }
        else {

            return <FileUploadPanel
                onDrop={this.onDrop}
                disabled={this.props.readOnly}
                busy={this.state.uploading}
            >
                Datei hier ablegen<br/><br/>oder klicken um<br/>Datei auszuwählen
            </FileUploadPanel>;
        }
    }
}

ObjectMediaURLSupplement.propTypes = {
    onObjectValueChange: PropTypes.func.isRequired,
    fieldDef: PropTypes.object.isRequired,
    objectId: PropTypes.string,
    readOnly: PropTypes.bool,
    value: PropTypes.any
};

const styles = {
    media: {
        width: 204,
        height: 204,
        backgroundColor: "#cccccc"
    }
};

export default connect(undefined, {openMediaOverlayForUrl, uploadMediaFile})(withStyles(styles)(ObjectMediaURLSupplement));